export const animateCellText = (father?: HTMLElement) => {
  const children = father?.getElementsByClassName('checkOverflow');
  Array.from(children ?? []).forEach(function (child) {
    if (child.scrollWidth > child.clientWidth + 6) {
      child.classList.add('animatedCell');
    }
  });
  const removeClass = () => {
    Array.from(children ?? []).forEach(function (child) {
      if (child.scrollWidth > child.clientWidth) {
        child.classList.remove('animatedCell');
      }
    });
    father?.removeEventListener('mouseleave', removeClass);
  };
  father?.addEventListener('mouseleave', removeClass);
};

export const cleanID = (id: string) => {
  return id.replace(/[^a-zA-Z0-9_-]/g, '');
};

export const getInk = (el: EventTarget & Element) => {
  for (let i = 0; i < el.children.length; i++) {
    if (
      typeof el.children[i].className === 'string' &&
      el.children[i].className.indexOf('p-ink') !== -1
    ) {
      return el.children[i];
    }
  }
  return null;
};

export const removeClass = (
  element: EventTarget & Element,
  className: string
) => {
  if (element.classList) element.classList.remove(className);
  else
    element.className = element.className.replace(
      new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'),
      ' '
    );
};
